import { render, staticRenderFns } from "./PrizePicture.vue?vue&type=template&id=5742f310&scoped=true&"
import script from "./PrizePicture.vue?vue&type=script&lang=js&"
export * from "./PrizePicture.vue?vue&type=script&lang=js&"
import style0 from "./PrizePicture.vue?vue&type=style&index=0&id=5742f310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742f310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5742f310')) {
      api.createRecord('5742f310', component.options)
    } else {
      api.reload('5742f310', component.options)
    }
    module.hot.accept("./PrizePicture.vue?vue&type=template&id=5742f310&scoped=true&", function () {
      api.rerender('5742f310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/PrizePicture.vue"
export default component.exports